import { appReducer } from '@store/StaticStore/appSlice'
import { authReducer } from '@store/StaticStore/authSlice'
import { combineReducers, Reducer } from 'redux'
import { StoreWithAsyncReducer } from 'AppTypes'
import { configureStore as createStore } from '@reduxjs/toolkit'

// Define the Reducers that will always be present in the application
const staticReducers = {
  app: appReducer,
  auth: authReducer
}

type TStaticReducer = typeof staticReducers

export type TStaticState = { [x in keyof TStaticReducer]: ReturnType<typeof staticReducers[x]> }

type AsynReducer = { [x: string]: Reducer<any, any> }

function createReducer (asyncReducers?: AsynReducer) {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers
  })
}

// Configure the store
export function configureStore () {
  const store = createStore({
    reducer: createReducer(),
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false
      })
  }) as StoreWithAsyncReducer

  // Add a dictionary to keep track of the registered async reducers
  store.asyncReducers = {}

  // Create an inject reducer function
  // This function adds the async reducer, and creates a new combined reducer
  store.injectReducer = (key: string | number, asyncReducer: any) => {
    if (store.asyncReducers[key]) return
    store.asyncReducers[key] = asyncReducer
    store.replaceReducer(createReducer(store.asyncReducers))
  }

  store.removeAll = () => {
    store.asyncReducers = {}
    store.replaceReducer(createReducer())
  }

  // Return the modified store
  return store
}

export const store = configureStore()
